module.exports = __webpack_public_path__ + "img/phone-4.40846a40.jpg";